import e from "micromatch";

function r() {
  return (r = Object.assign || function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];

      for (var t in n) {
        Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
      }
    }

    return e;
  }).apply(this, arguments);
}

var n = {
  nocase: !0
},
    t = {
  contains: !0
};
export default function (a, o, i) {
  void 0 === i && (i = {});
  var c = r({}, n, i, t),
      l = [];

  if (a && o.length >= 1) {
    var f = e.makeRe(o, c).exec(a);
    if (f && f[0]) for (var s, u = new RegExp(f[0], "gi"); null !== (s = u.exec(a));) {
      var v = s.index,
          p = u.lastIndex,
          h = a.slice(v, p);
      l.push({
        start: v,
        end: p,
        value: h
      });
    }
  }

  return l;
}